import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import AutoPayrollCalculation from "./AutoPayrollCalculation";
import EmployeeAutoPayroll from "./EmployeeAutoPayroll";

export default function AutoPayrollWrapper() {
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          setCurrentUser(user);
          try {
            const userDocRef = doc(db, "Users", user.uid);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
              const userRole = userDoc.data().role || "";
              setUserRole(userRole);
            } else {
              setUserRole("employee"); // Default to employee if no role found
            }
          } catch (error) {
            console.error("Error fetching user role:", error);
            setUserRole("employee"); // Default to employee on error
          }
        } else {
          setUserRole(null);
        }
        setLoading(false);
      });
    };

    fetchUserRole();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <Spinner animation="border" variant="primary" size="lg" />
          <p className="mt-3 text-muted">Loading payroll system...</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <i className="ri-error-warning-line display-1 text-danger mb-3"></i>
          <h4>Authentication Required</h4>
          <p className="text-muted">Please log in to access your payroll information.</p>
        </div>
      </div>
    );
  }

  // Show admin view for admin users, employee view for everyone else
  if (userRole === "admin") {
    return <AutoPayrollCalculation />;
  } else {
    return <EmployeeAutoPayroll />;
  }
}
